import React, { useState, useEffect } from 'react'
import { LoginCheck, Log } from "../Facturas/Fetch/Login";
import { useNavigate } from "react-router";
import Logo from "../logo.svg";
export default function Login() {

    let navigate = useNavigate();
    const [User, setUser] = useState({ show: false, error: '', loading: false, mail: '', pass: '', check: false })

    useEffect(() => {
        if (localStorage.getItem("ContaKMP")) {
            LoginCheck(localStorage.getItem("ContaKMP")).then(res => {
                if (res === '') {
                    setUser(v => ({
                        ...v,
                        show: true,
                        error: '',
                        mail: '',
                        pass: '',
                        check: false,
                    }));
                    localStorage.removeItem("ContaKMP");
                } else {
                    localStorage.setItem("ContaKMP", res);
                    navigate("/FindFactura");
                }
            }).catch(e => {
                console.log(e)
            })
        } else {
            setUser(v => ({
                ...v,
                show: true,
                error: '',
                mail: '',
                pass: '',
                check: false
            }));
        }
    }, [navigate, setUser])

    const Iniciar = (e) => {
        e.preventDefault();
        Checking();
        Log(User).then(res => {
            if (res.length > 0) {
                localStorage.setItem("ContaKMP", res);
                navigate("/FindFactura");
            } else {
                setUser(v => ({
                    ...v,
                    show: true,
                    error: 'Ingrese el usuario y contraseña correcto',
                    loading: false,
                    check: false
                }));
            }
        })
    }

    const Checking = () => {
        setUser(v => ({
            ...v,
            loading: true,
        }));
    }

    return (
        User.show === false ?
            <div>Loading...</div>
            :
            <form onSubmit={Iniciar} >
                <table border={1} >
                    <thead>
                        <tr>
                            <td colSpan={2}><img src={Logo} alt="Logo KMP" width={100} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}>Inicias Sesion</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Usuario</td>
                            <td><input disabled={User.loading} placeholder='Usuario' defaultValue={User.mail} required onChange={(e) => setUser({
                                ...User,
                                mail: e.target.value
                            })} /></td>
                        </tr>
                        <tr>
                            <td>Contraseña</td>
                            <td><input disabled={User.loading} type='password' defaultValue={User.pass} placeholder='Contraseña' required onChange={(e) => setUser({
                                ...User,
                                pass: e.target.value
                            })} /></td>
                        </tr>
                        <tr>
                            <td>Mantener sesion</td>
                            <td><input disabled={User.loading} type='checkbox' onClick={(e) => {
                                setUser({
                                    ...User,
                                    check: e.target.checked
                                })
                            }} /></td>
                        </tr>
                        <tr>
                            <td colSpan={2}><button disabled={User.loading} type="submit">Iniciar Sesión</button></td>
                        </tr>
                        {
                            User.error === '' ?
                                ''
                                :
                                <tr>
                                    <td colSpan={2}><span>{User.error}</span></td>
                                </tr>
                        }
                    </tbody>
                </table>

            </form>
    )
}
